import { useHistory } from "react-router-dom";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { headerColor } from "./lib/Color";

const Header: React.FC = () => {
  let history = useHistory();
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      root: {
        flexGrow: 1,
      },
      title: {
      },
    })
  );
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ backgroundColor: headerColor }}>
        <Toolbar>
          <Typography variant="h6" className={classes.title} onClick={() => history.push("/")}>
            Dragon Simulator
          </Typography>
          <Button
            color="inherit"
            onClick={() => history.push("/")}
          >
            PvP
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Header;
